import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const SessionOverrideModal = ({ show, onCancel, onOverride }) => {
  const modalStyles = {
    backgroundColor: "#27568B",
    color: '#ffffff',
    borderRadius: '5px',
    padding: '30px 20px',
    textAlign: 'center',
  };

  
  const iconCircle = {
    backgroundColor: '#2BB2FF',
    width: '60px',
    height: '60px',
    margin: '0 auto 20px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const exclamationStyle = {
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#ffffff',
  };

  const buttonStyle = {
    padding: '10px 30px',
    borderRadius: '8px',
    fontWeight: 'bold',
  };

  return (
    <Modal show={show} centered size='sm' backdrop="static" keyboard={false}>
      <Modal.Body style={modalStyles}>
        <div style={iconCircle}>
          <span style={exclamationStyle}>!</span>
        </div>
        <h4 style={{ fontWeight: '600', marginBottom: '15px' }}>Session override</h4>
        <p style={{ color: '#cbd5e1', marginBottom: '30px' }}>
        User is already logged in from Other Terminal. Do you want to override this session?
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
          <Button
            variant="dark"
            onClick={onCancel}
             style={{
                  backgroundColor: "#f3f4f6",
                  border: "1px solid rgb(119, 125, 137)",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  fontWeight: "500",
                  color: "#374151",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                }}
          >
            Cancel
          </Button>
          <Button
            onClick={onOverride}
            style={{
              ...buttonStyle,
              backgroundColor: '#2BB2FF',
              border: 'none',
              padding: "4px 12px",
              borderRadius: "4px",
            }}
          >
            Override
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SessionOverrideModal;
